(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["swatch-filter-navigation"] && !Shopify.designMode) return;
  try {
    
class SwatchFilter {
  constructor() {
    this.container = document.querySelector("[data-filter-navigation]");
    if (!this.container) return;

    this.maxSelections = 4;
    this.selectedSwatches = new Map();
    this.hasLoadedSwatches = false;

    this.initElements();
    this.initData();
    this.initSelectionData();
    this.bindEvents();
    this.initFormElements();
    this.hideFormInitially();
    this.createMiniCart();
    this.loadSavedSwatches();
    this.updateStep2Headings();
    this.initMobileElements();

    this.searchInputs = [
      document.querySelector("#swatchSearch"),
      document.querySelector("#swatchSearchPanel")
    ].filter(input => input);
    this.searchClearButton = document.querySelector(".swatch-search-clear");
    if (this.searchInputs.length > 0 && this.searchClearButton) {
      this.initSearch();
    }

    this.initPreselectedFilters();
  }


  initPreselectedFilters() {
    const rawPreselectedData = localStorage.getItem("preselectedSwatchData");
    if (!rawPreselectedData) {
      return;
    }
    const preselectedData = JSON.parse(rawPreselectedData);

    console.log(preselectedData);
    
    if (!preselectedData || !preselectedData.title) {
      return;
    }

    const selectFilterButton = async (filterType, collection, value, toggleFn, dataAttr = 'filterValue') => {
      const handleizedValue = this._handleize(value); 
      
      if (filterType === 'room') {
         const desktopRoomStep = document.querySelector('.filter-steps > .filter-step[data-step="room"]');
         if(desktopRoomStep) desktopRoomStep.setAttribute("data-active", "true");
      } else if (filterType === 'furniture') {
        this.updateFurnitureVisibility();
      } else if (filterType === 'brand') {
        this.updateBrandVisibility();
      } else if (filterType === 'material') {
        this.updateMaterialVisibility();
      }
      
      await new Promise(resolve => setTimeout(resolve, 150));

      const button = Array.from(collection).find(btn => {
        const btnValue = btn.dataset[dataAttr]?.toLowerCase(); 
        const isHidden = btn.classList.contains('hidden');
        if (btnValue === handleizedValue && !isHidden) { 
          return true;
        }
        return false;
      });

      if (button) {
        toggleFn.call(this, button, button.dataset[dataAttr]);
        return true;
      } else {
        Array.from(collection).forEach(btn => {
            const currentBtnHandleized = btn.dataset[dataAttr];
            if(currentBtnHandleized === handleizedValue){
            }
        });
        return false;
      }
    };

    const applyFilters = async () => {
      try {
        let success = true;

        if (preselectedData.rooms?.length > 0 && success) {
          const firstRoom = preselectedData.rooms[0];
          if (firstRoom) {
            success = await selectFilterButton('room', this.roomButtons, firstRoom, this.toggleRoom);
          }
          if (success) await new Promise(resolve => setTimeout(resolve, 450));
        }

        if (preselectedData.furniture?.length > 0 && this.selectedRooms.size > 0 && success) {
          const firstFurniture = preselectedData.furniture[0];
          if (firstFurniture) {
            success = await selectFilterButton('furniture', this.furnitureButtons, firstFurniture, this.toggleFurniture);
          }
          if (success) await new Promise(resolve => setTimeout(resolve, 450));
        } else if (preselectedData.furniture?.length > 0 && (!this.selectedRooms.size > 0 || !success) ) {
        }


        if (preselectedData.brand && preselectedData.brand !== "Unknown" && this.selectedFurniture.size > 0 && success) {
          success = await selectFilterButton('brand', this.brandButtons, preselectedData.brand, this.toggleBrand, 'brandId');
          if (success) await new Promise(resolve => setTimeout(resolve, 450));

        } else if (preselectedData.brand && preselectedData.brand !== "Unknown" && (!this.selectedFurniture.size > 0 || !success)) {
        }


        if (preselectedData.material && preselectedData.material !== "Unknown" && this.selectedBrands.size > 0 && success) {
          success = await selectFilterButton('material', this.materialButtons, preselectedData.material, this.toggleMaterial, 'filterValue');
          if (success) await new Promise(resolve => setTimeout(resolve, 250));
        } else if (preselectedData.material && preselectedData.material !== "Unknown" && (!this.selectedBrands.size > 0 || !success)) {
        }
        
        if (this.selectedMaterial) {
            const desktopColorStep = document.querySelector('.filter-steps > .filter-step[data-step="color"]');
            if(desktopColorStep) desktopColorStep.setAttribute("data-active", "true");
            const mobileColorContent = document.querySelector('.mobile-accordion .accordion-content[data-step="color"]');
            if(mobileColorContent) mobileColorContent.setAttribute("data-active", "true");
        }

        await new Promise(resolve => setTimeout(resolve, 300));
        this.filterSwatches(); 
        this.updateMobileAccordionState(); 

        const swatchItems = document.querySelectorAll('.swatch-item:not(.hidden-swatch)');
        const matchingSwatch = Array.from(swatchItems).find(swatch => 
          swatch.querySelector('.swatch-title')?.textContent?.trim().toLowerCase() === 
          preselectedData.title.toLowerCase()
        );

        if (matchingSwatch) {

          // alert('scrollIntoView');

          matchingSwatch.scrollIntoView({ behavior: 'smooth', block: 'center' });
          matchingSwatch.classList.add('highlighted-swatch');
          setTimeout(() => matchingSwatch.classList.remove('highlighted-swatch'), 3000);

          const swatchId = this.generateSwatchId(matchingSwatch);
          matchingSwatch.dataset.swatchId = swatchId; 

          if (!this.selectedSwatches.has(swatchId)) {
            if (this.selectedSwatches.size < this.maxSelections) {
              this.addSelection(matchingSwatch, swatchId);
            } else {
              this.showMaxSwatchLimitMessage();
            }
          }
        } else {
        }

        localStorage.removeItem('preselectedSwatchData');
      } catch (error)
       {
      }
    };
    applyFilters();
  }

  _handleize(str) {
    if (typeof str !== 'string') return '';
    let s = str.toLowerCase();
    s = s.replace(/&/g, ' '); 
    s = s.replace(/&/g, ' '); 
    s = s.replace(/[^\w\s-]/g, '');
    s = s.replace(/\s+/g, '-');    
    s = s.replace(/-+/g, '-');     
    s = s.replace(/^-+|-+$/g, '');  
    return s;
  }

  getText(key, fallbackText) {
    if (this.container && this.container.dataset[key]) {
      return this.container.dataset[key];
    }
    return fallbackText;
  }

  initElements() {
    this.roomButtons = this.container.querySelectorAll('[data-step="room"] .option-button, .accordion-content[data-step="room"] .option-button');
    this.furnitureButtons = this.container.querySelectorAll('[data-step="furniture"] .option-button, .accordion-content[data-step="furniture"] .option-button');
    this.brandButtons = this.container.querySelectorAll('[data-step="brand"] .option-button, .accordion-content[data-step="brand"] .option-button');
    this.materialButtons = this.container.querySelectorAll('[data-step="material"] .option-button, .accordion-content[data-step="material"] .option-button');
    this.colorButtons = this.container.querySelectorAll('[data-step="color"] .option-button, .accordion-content[data-step="color"] .option-button');

    this.selectedRoomFilter = this.container.querySelector("[data-filter-room], .mobile-selected-filters [data-filter-room]");
    this.selectedFurnitureFilter = this.container.querySelector("[data-filter-furniture], .mobile-selected-filters [data-filter-furniture]");
    this.selectedBrandFilter = this.container.querySelector("[data-filter-brand], .mobile-selected-filters [data-filter-brand]");
    this.selectedMaterialFilter = this.container.querySelector("[data-filter-material], .mobile-selected-filters [data-filter-material]");
    this.selectedColorFilter = this.container.querySelector("[data-filter-color], .mobile-selected-filters [data-filter-color]");
    
    this.furnitureStep = this.container.querySelector('[data-step="furniture"], .accordion-content[data-step="furniture"]');
    this.brandStep = this.container.querySelector('[data-step="brand"], .accordion-content[data-step="brand"]');
    this.materialStep = this.container.querySelector('[data-step="material"], .accordion-content[data-step="material"]');
    this.colorStep = this.container.querySelector('[data-step="color"], .accordion-content[data-step="color"]');
    
    this.swatchGrid = document.querySelector("[data-swatch-grid]");
    this.selectedSwatchesGrid = document.querySelector(".selected-swatches-grid");
    this.selectedSwatchesContainer = document.querySelector(".selected-swatches-container");

    this.step2RoomSelectedTextElements = document.querySelectorAll(".room_selected_text");
    this.step2TitleTextElements = document.querySelectorAll(".step_room_select_text"); 
    this.swatchLimitErrorMessages = document.querySelectorAll('.swatch-limit-error-message');
  }

  initMobileElements() {
    this.mobileFilterToggle = document.querySelector(".mobile-filter-toggle");
    this.mobileFilterPanel = document.querySelector(".mobile-filter-panel");
    this.mobileSwatchesToggle = document.querySelector(".mobile-swatches-toggle");
    this.mobileSwatchesPanel = document.querySelector(".mobile-swatches-panel");
    this.mobileOverlay = document.querySelector(".mobile-panel-overlay");
    this.mobilePanelCloseButtons = document.querySelectorAll(".mobile-panel-close");
    this.accordionToggles = document.querySelectorAll("[data-accordion-toggle]");
    
    this.syncMobileSelectedFilters();
    
    this.bindMobileEvents();
    this.updateMobileSwatchesCount();
  }

  initData() {
    this.selectedRooms = new Set();
    this.selectedFurniture = new Set();
    this.selectedBrands = new Set();
    this.selectedMaterial = null;
    this.selectedColor = null;

    this.roomData = new Map();
    this.furnitureData = new Map();
    this.brandData = new Map();
    this.materialData = new Map();
    this.colorData = new Map();

    this.initMap(this.roomButtons, this.roomData);
    this.initMap(this.furnitureButtons, this.furnitureData, 'roomId');
    this.initMap(this.brandButtons, this.brandData);
    this.initMap(this.materialButtons, this.materialData, 'filterValue');
    this.initMap(this.colorButtons, this.colorData, 'filterValue');
  }

  initMap(buttons, map, extraKey = null) {
    buttons.forEach(button => {
      const id = button.dataset.brandId || button.dataset.filterValue;
      if (!id) return;
      map.set(id, {
        name: button.querySelector('span').textContent.trim(),
        element: button,
        ...(extraKey && { [extraKey]: button.dataset[extraKey] })
      });
    });
  }

  initSelectionData() {
    this.selectedSwatches = new Map();
    this.updateRemainingSlots();
  }

  bindEvents() {
    this.bindButtonEvents(this.roomButtons, 'toggleRoom');
    this.bindButtonEvents(this.furnitureButtons, 'toggleFurniture');
    this.bindButtonEvents(this.brandButtons, 'toggleBrand', 'brandId');
    this.bindButtonEvents(this.materialButtons, 'toggleMaterial', 'filterValue');
    this.bindButtonEvents(this.colorButtons, "toggleColor", "filterValue");

    this.bindClearEvent(this.selectedRoomFilter, 'clearRooms');
    this.bindClearEvent(this.selectedFurnitureFilter, 'clearFurniture');
    this.bindClearEvent(this.selectedBrandFilter, 'clearBrands');
    this.bindClearEvent(this.selectedMaterialFilter, 'clearMaterial');
    this.bindClearEvent(this.selectedColorFilter, 'clearColor');
    

    this.swatchGrid && this.swatchGrid.addEventListener("click", (e) => {
        const swatchItem = e.target.closest(".swatch-item:not(.hidden-swatch)");
        if (swatchItem && !e.target.closest('.swatch-info-button')) {
            this.toggleSwatchSelection(swatchItem);
        }
    });
        this.selectedSwatchesGrid && this.selectedSwatchesGrid.addEventListener("click", (e) => {
        const removeButton = e.target.closest(".remove-selected");
        if (removeButton) {
            const swatchId = removeButton.closest(".selected-swatch-slot").dataset.swatchId;
            this.removeSelection(swatchId);
        }
    });

    const formSwatchGrid = document.querySelector('.swatch_form_selected_swatches .selected-swatches-grid');
    formSwatchGrid && formSwatchGrid.addEventListener("click", (e) => {
        const removeButton = e.target.closest(".remove-selected");
        if (removeButton) {
            const swatchId = removeButton.closest(".selected-swatch-slot").dataset.swatchId;
            this.removeSelection(swatchId);
        }
    });

    const mobileSwatchesGrid = document.querySelector('.mobile-swatches-panel .selected-swatches-grid');
    if (mobileSwatchesGrid) {
      mobileSwatchesGrid.addEventListener('click', (e) => {
        const removeButton = e.target.closest('.remove-selected');
        if (removeButton) {
          const slot = removeButton.closest('.selected-swatch-slot');
          const swatchId = slot.dataset.swatchId;
          this.removeSelection(swatchId);
        }
      });
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        this.closeMobilePanels();
      }
    });

     window.addEventListener("klaviyoForms", function(e) { 
      if(e.detail.type == 'submit'){
        const backButton = document.querySelector('.back-button')
        backButton.classList.add('hidden');
        localStorage.removeItem('selectedSwatches');
      }
    });

    document.addEventListener('click', (e) => {
      const miniCartToggle = e.target.closest('.mini-cart-toggle');
      if (miniCartToggle) {
        const miniCart = document.querySelector('.swatch-mini-cart');
        miniCart.classList.toggle('expanded');
        miniCartToggle.textContent = miniCart.classList.contains('expanded') ? '▲' : '▼';
      }

      const miniCartRemove = e.target.closest('.mini-cart-remove');
      if (miniCartRemove) {
        e.preventDefault();
        e.stopPropagation();
        const swatchId = miniCartRemove.dataset.swatchId;
        this.removeSelection(swatchId);
      }
    });
  }

  syncMobileSelectedFilters() {
    const desktopFilters = document.querySelectorAll(".selected-filters:not(.mobile-selected-filters) .selected-filter");
    const mobileFilters = document.querySelectorAll(".mobile-selected-filters .selected-filter");
    
    if (desktopFilters.length > 0 && mobileFilters.length > 0) {
      for (let i = 0; i < desktopFilters.length; i++) {
        const desktopFilter = desktopFilters[i];
        const mobileFilter = mobileFilters[i];
        
        if (desktopFilter && mobileFilter) {
          mobileFilter.querySelector("span").innerHTML = desktopFilter.querySelector("span").innerHTML;
          if (desktopFilter.classList.contains("hidden")) {
            mobileFilter.classList.add("hidden");
          } else {
            mobileFilter.classList.remove("hidden");
          }
        }
      }
    }
  }

  bindMobileEvents() {
    if (!this.isMobile()) return;
    
    if (this.mobileFilterToggle) {
      this.mobileFilterToggle.addEventListener("click", () => {
        this.openMobilePanel(this.mobileFilterPanel);
      });
    }
    
    if (this.mobileSwatchesToggle) {
      this.mobileSwatchesToggle.addEventListener("click", () => {
        this.openMobilePanel(this.mobileSwatchesPanel);
      });
    }
    
    if (this.mobilePanelCloseButtons) {
      this.mobilePanelCloseButtons.forEach(button => {
        button.addEventListener("click", () => {
          this.closeMobilePanels();
        });
      });
    }
    
    if (this.mobileOverlay) {
      this.mobileOverlay.addEventListener("click", () => {
        this.closeMobilePanels();
      });
    }
    
    if (this.accordionToggles) {
      this.accordionToggles.forEach(accordionToggle => {
        accordionToggle.addEventListener("click", () => {
          if (accordionToggle.classList.contains('disabled')) {
            return; 
          }
          
          const accordionItem = accordionToggle.closest('.accordion-item');
          if (!accordionItem) return;
          const accordionContent = accordionItem.querySelector('.accordion-content');
          if (!accordionContent) return;

          const mobileAccordionParent = accordionToggle.closest('.mobile-accordion');
          if (!mobileAccordionParent) return;

          const isActive = accordionToggle.classList.contains("active");
          
          mobileAccordionParent.querySelectorAll(".accordion-header").forEach(header => {
            if (header !== accordionToggle) {
              header.classList.remove("active");
            }
          });
          mobileAccordionParent.querySelectorAll(".accordion-content").forEach(content => {
            if (content !== accordionContent) {
              content.classList.remove("accordion-active");
            }
          });
          
          if (!isActive) {
            accordionContent.classList.add("accordion-active");
            accordionToggle.classList.add("active");
          } else {
            accordionContent.classList.remove("accordion-active");
            accordionToggle.classList.remove("active");
          }
        });
      });
    }

    const mobileRemoveFilters = document.querySelectorAll(".mobile-selected-filters .remove-filter");
    if (mobileRemoveFilters) {
      mobileRemoveFilters.forEach(button => {
        button.addEventListener("click", e => {
          e.preventDefault();
          const filterType = button.getAttribute("data-remove");
          if (filterType) {
            this[`clear${filterType.charAt(0).toUpperCase() + filterType.slice(1)}`]();
          }
        });
      });
    }
  }

  openMobilePanel(e) {
    if (!e) {
      return;
    }

    this.closeMobilePanels();
    e.classList.add("panel-open");
    this.mobileOverlay.classList.add("overlay-visible");
    document.body.classList.add("panel-open-body");

    if (e.classList.contains("mobile-swatches-panel")) {
      const grid = e.querySelector(".selected-swatches-grid");
      if (grid) {
        grid.innerHTML = "";
        this.selectedSwatches.forEach((swatchEntry, swatchId) => {
          if (!swatchEntry || !swatchEntry.savedData) {
            return;
          }
          const slot = document.createElement("div");
          slot.className = "selected-swatch-slot";
          slot.innerHTML = this.createSelectedSwatchContent(swatchEntry.savedData); // Pass savedData
          slot.dataset.swatchId = swatchId;
          grid.appendChild(slot);
        });
      } else {

      }
    }
  }

  closeMobilePanels() {
    document.querySelectorAll('.mobile-filter-panel, .mobile-swatches-panel').forEach(panel => {
      panel.classList.remove('panel-open');
    });
    this.mobileOverlay.classList.remove('overlay-visible');
    document.body.classList.remove('panel-open-body');
  }

  updateMobileSwatchesCount() {
    const e = this.selectedSwatches.size;
    const t = document.querySelector(".mobile-swatches-toggle");
    if (t) {
        const s = t.querySelector(".swatches-count");
        s && (s.textContent = e.toString());
        e > 0 ? t.classList.add("has-swatches") : t.classList.remove("has-swatches");
    }
    this.updateSwatchCountDisplay();
  }

  updateSwatchCountDisplay() {
    const count = this.selectedSwatches.size;
    document.querySelectorAll(".swatch_count").forEach(el => {
      if (el) {
        // Always display the actual count, but visually cap if needed elsewhere (e.g., warnings)
        // Or enforce max display here if required:
        let displayCount = count > this.maxSelections ? this.maxSelections : count;
         el.textContent = displayCount.toString();
      }
    });
    // Also update mobile count display directly
    const mobileToggle = document.querySelector(".mobile-swatches-toggle");
     if (mobileToggle) {
        const mobileCountEl = mobileToggle.querySelector(".swatches-count");
        if (mobileCountEl) {
            mobileCountEl.textContent = count.toString(); // Show actual count here
        }
        if (count > 0) {
            mobileToggle.classList.add("has-swatches");
        } else {
            mobileToggle.classList.remove("has-swatches");
        }
    }
  }


  isMobile() {
    return window.innerWidth < 768;
  }

  initFormElements() {
      this.contactForm = document.querySelector('#dd7414da-9be5-4689-bd29-6320b691f8fb');
      this.formContainer = document.querySelector('.hide-swatch-form');
      this.openFormButtons = document.querySelectorAll('.open-form-button');
      this.orderButtons = document.querySelectorAll('.open-form-button.swipe-green-button');
      this.mobileSelectedSwatchesPanel = document.querySelectorAll('.mobile-panel-overlay');
      this.mobileSelectedSwatches = document.querySelectorAll('.mobile-swatches-panel');
      this.backButton = document.querySelector('.back-button');

      if (this.openFormButtons) {
          this.openFormButtons.forEach(button => {
              button.addEventListener('click', () => this.showForm());
              button.addEventListener('click', () => this.insertSwatchKlaviyo());

              // console.log('fires on mobile?');
          });
      }

      if (this.backButton) {
          this.backButton.addEventListener('click', () => this.hideForm());
      }
      this.updateOrderButtonState();
  }

  hideFormInitially() {
      if (this.formContainer) {
          this.formContainer.classList.remove('active');
      }
  }

  insertSwatchKlaviyo(attempt = 0) {
    const savedSwatchesRaw = localStorage.getItem("selectedSwatches");
    let savedSwatches = [];

    try {
      if (savedSwatchesRaw) {
        savedSwatches = JSON.parse(savedSwatchesRaw);
      }
    } catch (e) {
      console.error("Invalid JSON in selectedSwatches:", e);
      return;
    }

    const getKlaviyoFields = (propertyName) => {
      return Array.from(document.querySelectorAll(
        `.klaviyo-form-${formID} input[id^="${propertyName}_"]`
      ));
    };

    const hideKlaviyoField = (input) => {
      const fieldContainer =
        input.closest('[data-testid="form-row"]') ||
        input.closest('[data-testid="form-component"]') ||
        input;

      fieldContainer.classList.add('hidden-input');
    };

    let matchedSwatchFields = 0;

    inputProperties.forEach((propertyName, index) => {
      const swatch = savedSwatches[index];
      const fields = getKlaviyoFields(propertyName);
      matchedSwatchFields += fields.length;

      fields.forEach((input) => {
        input.value = swatch?.title || 'No swatch selected.';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        hideKlaviyoField(input);
      });
    });

    imageProperties.forEach((propertyName, index) => {
      const swatch = savedSwatches[index];
      const fields = getKlaviyoFields(propertyName);
      matchedSwatchFields += fields.length;

      fields.forEach((inputImage) => {
        inputImage.value = swatch?.imgSrc || 'No swatch selected.';
        inputImage.dispatchEvent(new Event('input', { bubbles: true }));
        inputImage.dispatchEvent(new Event('change', { bubbles: true }));
        hideKlaviyoField(inputImage);
      });
    });

    getKlaviyoFields(countryProperty).forEach((countryField) => {
      const placeholder = countryField.placeholder || '';
      countryField.readOnly = true;

      countryField.value = placeholder;
      countryField.dispatchEvent(new Event('input', { bubbles: true }));
      countryField.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (matchedSwatchFields === 0 && attempt < 20) {
      setTimeout(() => this.insertSwatchKlaviyo(attempt + 1), 100);
    }
  }

  showForm() {

      const klaviyoFormEvent = new CustomEvent("klaviyoForms", {
            detail: {
                formId: formID,
                companyId: 'SV98rX'
            }
          });
        window.dispatchEvent(klaviyoFormEvent);

      if (this.formContainer) {
          this.formContainer.classList.add('active');
      }

      if (this.mobileSwatchesToggle) {
        this.mobileSwatchesToggle.classList.add("hidden");
    }
      
      if (this.mobileSelectedSwatchesPanel) {
          this.mobileSelectedSwatchesPanel.forEach(swatch => {
              swatch.classList.remove('overlay-visible');
          });
      }

      if (this.mobileSelectedSwatches) {
          this.mobileSelectedSwatches.forEach(swatch => {
              swatch.classList.remove('panel-open');
          });
      }
  }

  hideForm() {
      if (this.formContainer) {
          this.formContainer.classList.remove('active');
          document.body.classList.remove('panel-open-body');
      }

      if (this.mobileSwatchesToggle) {
        this.mobileSwatchesToggle.classList.remove("hidden");
      }
  }

  updateHiddenFields() {
    if (!this.contactForm) return;
    const selectedArray = Array.from(this.selectedSwatches.values());

    for (let i = 0; i < this.maxSelections; i++) {
        const inputField = this.contactForm.querySelector(`#swatch_${i + 1}`);
        if (inputField) {
            if (i < selectedArray.length) {
                const swatchInfo = selectedArray[i];
                const title = swatchInfo.element ? swatchInfo.element.querySelector('.swatch-title')?.textContent : (swatchInfo.savedData?.title || 'Unnamed Swatch');
                inputField.value = title;
            } else {
                inputField.value = "";
            }
        }
    }
  }

  bindButtonEvents(buttons, method, datasetKey = 'filterValue') {
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this[method](button, button.dataset[datasetKey]);
      });
    }); 
  }

  bindClearEvent(filterElement, method) {
    const button = filterElement.querySelector('.remove-filter');
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this[method]();
      });
    }
  }

  initSearch() {
    if (this.searchInputs.length === 0 || !this.searchClearButton) {
      return;
    }
    this.searchButton = document.querySelector('.swatch-search-btn');
    this.searchInputs.forEach(input => {
      input.addEventListener("keydown", (e) => {
        if (e.key === 'Enter') {
          this.handleSearch(input);
        }
      });
    });

    if (this.searchButton) {
      this.searchButton.addEventListener("click", () => {
        const activeInput = this.searchInputs.find(input => input.value.trim()) || this.searchInputs[0];
        this.handleSearch(activeInput);
      });
    }

    this.searchClearButton.addEventListener("click", () => {
      this.clearSearch();
      const priceTiersIntro3 = document.querySelectorAll('.price-tier-section-intro');
      priceTiersIntro3.forEach(el => {
        el.style.display = 'none';
      });
    });
  }

  handleSearch(activeInput) {
    const searchTerm = activeInput.value.toLowerCase().trim();
    const swatches = document.querySelectorAll('.swatch-item');
    const priceTiers = document.querySelectorAll('.price-tier-section');
    this.searchClearButton.style.display = searchTerm ? 'block' : 'none';
    const priceTiersIntro = document.querySelector('.price-tier-section-intro');

    let matchedPriceTiers = new Set();

    swatches.forEach(swatch => {
      const title = swatch.querySelector('.swatch-title')?.textContent.toLowerCase() || '';
      const material = swatch.querySelector('.swatch-material')?.textContent.toLowerCase() || '';
      
      const matches = title.includes(searchTerm) || material.includes(searchTerm);


      
      if (searchTerm) {
            
        if (matches) {
          priceTiersIntro.style.display = 'block';
          // priceTiers add active class on mobile

          // priceTiersheadings add active class on mobile

          swatch.classList.remove('hidden-swatch', 'search-hidden');
          const priceTier = swatch.closest('.price-tier-section');
          const priceTierH = priceTier.querySelector('.price-tier-heading');
          if (priceTier) {
            priceTier.classList.add('active');
            priceTierH.classList.add('active');
            matchedPriceTiers.add(priceTier);
          }
        } else {
          swatch.classList.add('search-hidden');
        }
      } else {
        swatch.classList.remove('search-hidden');
      }
    });

    priceTiers.forEach(tier => {
      const visibleSwatches = Array.from(tier.querySelectorAll('.swatch-item:not(.hidden-swatch):not(.search-hidden)'));
      tier.style.display = visibleSwatches.length > 0 ? 'block' : 'none';      
    });

    this.searchInputs.forEach(input => {
      input.value = activeInput.value;
    });
  }

  shouldShowSwatches() {
    return this.selectedMaterial !== null;
  }

  showDuplicateWarning() {
    const warning = document.createElement("div");
    warning.className = "swatch-selection-full";
    warning.textContent = this.getText('textDuplicateWarning', 'This swatch is already in your selection');
    document.body.appendChild(warning);

    setTimeout(() => {
      warning.remove();
    }, 3000);
  }

  updateSelectedDisplay(element, selectedSet, filterType) {
    [element, document.querySelector(`.mobile-selected-filters [data-filter-${filterType}]`)].forEach(el => {
      if (!el) return;
      
      const contentSpan = el.querySelector("span");
      if (selectedSet.size > 0) {
        el.classList.remove("hidden");
        contentSpan.innerHTML = Array.from(selectedSet).map(id => {
          const dataEntry = this[`${filterType}Data`]?.get(id);
          const name = dataEntry?.name || id; 
          return `
            <div class="${filterType}-tag" data-${filterType}-id="${id}">
              ${name}
              <button class="remove-single-${filterType}" data-${filterType}-id="${id}">×</button>
            </div>
          `;
        }).join("");
        
        contentSpan.querySelectorAll(`.remove-single-${filterType}`).forEach(btn => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const idToRemove = btn.dataset[`${filterType}Id`];
            
            if (filterType === "room") {
              this.removeSingleRoom(idToRemove);
            } else if (filterType === "furniture") {
              this.removeSingleFurniture(idToRemove);
            } else if (filterType === "brand") {
              this.removeSingleBrand(idToRemove);
            }
          });
        });
      } else {
        el.classList.add("hidden");
        contentSpan.innerHTML = "";
      }
    });
  }

  removeSingleRoom(roomId) {
    const roomElement = Array.from(this.roomButtons).find(btn => btn.dataset.filterValue === roomId);
    
    this.selectedRooms.delete(roomId);
    
    if (roomElement) {
      roomElement.classList.remove("selected");
    }
    
    this.updateSelectedDisplay(this.selectedRoomFilter, this.selectedRooms, "room", "toggleRoom");
    this.updateFurnitureVisibility();
    this.updateBrandVisibility();
    this.updateStep2Headings();
    this.filterSwatches();
    this.updateMobileAccordionState();
  }

  removeSingleFurniture(furnitureId) {
    const furnitureElement = Array.from(this.furnitureButtons).find(btn => btn.dataset.filterValue === furnitureId);
    
    this.selectedFurniture.delete(furnitureId);
    
    if (furnitureElement) {
      furnitureElement.classList.remove("selected");
    }
    
    this.updateSelectedDisplay(this.selectedFurnitureFilter, this.selectedFurniture, "furniture", "toggleFurniture");
    this.updateBrandVisibility();
    this.filterSwatches();
    this.updateMobileAccordionState();
  }

  removeSingleBrand(brandId) {
    const brandElement = Array.from(this.brandButtons).find(btn => btn.dataset.brandId === brandId);
    
    this.selectedBrands.delete(brandId); 
    
    if (brandElement) {
      brandElement.classList.remove("selected"); 
    }
    
    this.updateSelectedDisplay(this.selectedBrandFilter, this.selectedBrands, "brand"); 
    this.filterSwatches(); 
    if(this.selectedBrands.size === 0) { 
        this.clearMaterial();
    }
    this.updateMobileAccordionState(); 
  }

  updateMobileAccordionState() {
    const furnitureHeader = document.querySelector('[data-accordion-toggle="furniture"]');
    const brandHeader = document.querySelector('[data-accordion-toggle="brand"]');
    const materialHeader = document.querySelector('[data-accordion-toggle="material"]');
    const colorHeader = document.querySelector('[data-accordion-toggle="color"]');

    let accordionToActivate = null;

    if (this.selectedRooms.size > 0) {
      if (this.selectedFurniture.size > 0) {
        if (this.selectedBrands.size > 0) {
          if (this.selectedMaterial !== null) {
            if (colorHeader && !colorHeader.classList.contains("active")) {
              accordionToActivate = colorHeader;
            }
          } else {
            if (materialHeader && !materialHeader.classList.contains("active")) {
              accordionToActivate = materialHeader;
            }
          }
        } else {
          if (brandHeader && !brandHeader.classList.contains("active")) {
            accordionToActivate = brandHeader;
          }
        }
      } else {
        if (furnitureHeader && !furnitureHeader.classList.contains("active")) {
          accordionToActivate = furnitureHeader;
        }
      }
    }

    if (accordionToActivate) {
      accordionToActivate.click();
    }
  }

  updateFurnitureVisibility() {
      const desktopFurnitureStep = document.querySelector('.filter-steps > .filter-step[data-step="furniture"]');
      const mobileAccordionContentFurniture = document.querySelector('.mobile-accordion .accordion-content[data-step="furniture"]');
      let canShowAnyFurniture = false;

      if (this.selectedRooms.size > 0) {
          this.furnitureButtons.forEach(button => {
              const furnitureRooms = (button.dataset.roomId || '').trim().split(' ').filter(Boolean);
              const isCompatible = Array.from(this.selectedRooms).some(selectedRoom => furnitureRooms.includes(selectedRoom));
              if (isCompatible) {
                  button.classList.remove("hidden");
                  canShowAnyFurniture = true;
              } else {
                  button.classList.add("hidden");
              }
          });
      } else {
          this.furnitureButtons.forEach(button => button.classList.add("hidden"));
      }

      if (canShowAnyFurniture) {
          if (desktopFurnitureStep) desktopFurnitureStep.setAttribute("data-active", "true");
          if (mobileAccordionContentFurniture) mobileAccordionContentFurniture.setAttribute("data-active", "true");
      } else {
          if (desktopFurnitureStep) desktopFurnitureStep.setAttribute("data-active", "false");
          if (mobileAccordionContentFurniture) {
              mobileAccordionContentFurniture.setAttribute("data-active", "false");
              mobileAccordionContentFurniture.classList.remove("accordion-active");
              const header = mobileAccordionContentFurniture.closest('.accordion-item')?.querySelector('.accordion-header');
              if (header) header.classList.remove("active");
          }
          if (this.selectedFurniture.size > 0) this.clearFurniture();
      }
      this.validateFurnitureSelections();
  }

  validateFurnitureSelections() {
    if (this.selectedRooms.size === 0) return;
    const selectedFurnitureArray = Array.from(this.selectedFurniture);
    selectedFurnitureArray.forEach(furnitureId => {
      const furnitureData = this.furnitureData.get(furnitureId);
      if (!furnitureData) return;
      
      const roomId = furnitureData.roomId;
      if (!this.selectedRooms.has(roomId)) {
        this.selectedFurniture.delete(furnitureId);
        furnitureData.element.classList.remove('selected');
      }
    });
    this.updateSelectedDisplay(this.selectedFurnitureFilter, this.selectedFurniture, 'furniture', 'toggleFurniture');
  }

  updateBrandVisibility() {
    const desktopBrandStep = document.querySelector('.filter-steps > .filter-step[data-step="brand"]');
    const mobileAccordionContentBrand = document.querySelector('.mobile-accordion .accordion-content[data-step="brand"]');
    let canShowAnyBrand = false;

    

    if (this.selectedRooms.size > 0 && this.selectedFurniture.size > 0) {
        this.brandButtons.forEach(button => {
            const brandRooms = (button.dataset.roomId || '').trim().split(' ').filter(Boolean);
            const brandFurniture = (button.dataset.furnitureId || '').trim().split(' ').filter(Boolean);
            const roomMatch = Array.from(this.selectedRooms).some(room => brandRooms.includes(room));
            const furnitureMatch = Array.from(this.selectedFurniture).some(furn => brandFurniture.includes(furn));

            if (roomMatch && furnitureMatch) {
                button.classList.remove("hidden");
                canShowAnyBrand = true;
            } else {
                button.classList.add("hidden");
            }
        });
    } else {
        this.brandButtons.forEach(button => button.classList.add("hidden"));
    }

    if (canShowAnyBrand) {
        if (desktopBrandStep) desktopBrandStep.setAttribute("data-active", "true");
        if (mobileAccordionContentBrand) mobileAccordionContentBrand.setAttribute("data-active", "true");
    } else {
        if (desktopBrandStep) desktopBrandStep.setAttribute("data-active", "false");
        if (mobileAccordionContentBrand) {
            mobileAccordionContentBrand.setAttribute("data-active", "false");
            mobileAccordionContentBrand.classList.remove("accordion-active");
            const header = mobileAccordionContentBrand.closest('.accordion-item')?.querySelector('.accordion-header');
            if (header) header.classList.remove("active");
        }
        if (this.selectedBrands.size > 0) this.clearBrands();
    }
    this.validateBrandSelections();
  }

  validateBrandSelections() {
    if (this.selectedRooms.size === 0 || this.selectedFurniture.size === 0) return;

    const selectedBrandsArray = Array.from(this.selectedBrands);
    
    selectedBrandsArray.forEach(brandId => {
      const brandElement = this.brandData.get(brandId)?.element;
      if (!brandElement) return;
      
      const buttonRooms = brandElement.dataset.roomId.trim().split(' ');
      const buttonFurniture = brandElement.dataset.furnitureId.trim().split(' ');
      
      const hasMatchingRoom = Array.from(this.selectedRooms).some(room => 
        buttonRooms.includes(room)
      );
      
      const hasMatchingFurniture = Array.from(this.selectedFurniture).some(furniture => 
        buttonFurniture.includes(furniture)
      );
      
      if (!hasMatchingRoom || !hasMatchingFurniture) {
        this.selectedBrands.delete(brandId);
        brandElement.classList.remove('selected');
      }
    });
    
    this.updateSelectedDisplay(this.selectedBrandFilter, this.selectedBrands, 'brand', 'toggleBrand');
  }

  toggleSelection(collection, dataMap, id, buttonElement) {
    if (collection.has(id)) {
      collection.delete(id);
      buttonElement.classList.remove('selected');
    } else {
      collection.add(id);
      buttonElement.classList.add('selected');
    }
    return collection; 
  }

  toggleRoom(button, value) {
    if (button.classList.contains('selected') && this.selectedRooms.has(value)) {
      this.clearRooms();
    } else {
      this.selectedRooms.clear();
      this.roomButtons.forEach(btn => btn.classList.remove("selected"));
      
      this.selectedRooms.add(value);
      button.classList.add('selected');
      
      this.updateSelectedDisplay(this.selectedRoomFilter, this.selectedRooms, "room"); 
      this.clearFurniture(); 
      this.updateFurnitureVisibility(); 
      this.filterSwatches();
      this.updateStep2Headings();
      this.updateMobileAccordionState();
    }
  }

  toggleFurniture(button, value) {
    if (button.classList.contains('selected') && this.selectedFurniture.has(value)) {
      this.clearFurniture();
    } else {
      this.selectedFurniture.clear();
      this.furnitureButtons.forEach(btn => {
          if (btn !== button) btn.classList.remove("selected");
      });
      
      this.selectedFurniture.add(value);
      button.classList.add('selected');
      
      this.updateSelectedDisplay(this.selectedFurnitureFilter, this.selectedFurniture, "furniture"); 
      this.clearBrands(); 
      this.updateBrandVisibility(); 
      this.filterSwatches();
      this.updateMobileAccordionState();
    }
  }

  toggleBrand(button, value) {
    if (button.classList.contains('selected') && this.selectedBrands.has(value)) {
      this.clearBrands();
    } else {
      this.selectedBrands.clear();
      this.brandButtons.forEach(btn => {
          if (btn !== button) btn.classList.remove("selected")
      });
      
      this.selectedBrands.add(value);
      button.classList.add('selected');
      
      this.updateSelectedDisplay(this.selectedBrandFilter, this.selectedBrands, "brand"); 
      this.updateMaterialVisibility();
      this.filterSwatches();
      this.updateMobileAccordionState();
    }
  }

  updateMaterialVisibility() {
    const desktopMaterialStep = document.querySelector('.filter-steps > .filter-step[data-step="material"]');
    const mobileAccordionContentMaterial = document.querySelector('.mobile-accordion .accordion-content[data-step="material"]');
    
    if (this.selectedBrands.size > 0) {
        if(desktopMaterialStep) desktopMaterialStep.setAttribute("data-active", "true");
        if(mobileAccordionContentMaterial) mobileAccordionContentMaterial.setAttribute("data-active", "true");
    } else {
        if(desktopMaterialStep) desktopMaterialStep.setAttribute("data-active", "false");
        if(mobileAccordionContentMaterial) {
             mobileAccordionContentMaterial.setAttribute("data-active", "false");
             mobileAccordionContentMaterial.classList.remove("accordion-active");
             const header = mobileAccordionContentMaterial.closest('.accordion-item')?.querySelector('.accordion-header');
             if (header) header.classList.remove("active");
        }
        if (this.selectedMaterial) this.clearMaterial();
    }
  }

  toggleMaterial(button, value) {
    if (this.selectedMaterial === value) {
      this.clearMaterial(); 
    } else {
      this.selectedMaterial = value;
      this.materialButtons.forEach(btn => btn.classList.remove("selected"));
      button.classList.add("selected");
      this.updateMaterialDisplay(); 
      this.materialStep.setAttribute("data-active", "true");
      this.colorStep.setAttribute("data-active", "true");
      const colorAccordion = document.querySelector('[data-accordion-toggle="color"]');
      if (colorAccordion) colorAccordion.classList.remove("disabled");
      
      this.filterSwatches(); 
      this.updateMobileAccordionState();
    }
  }

  toggleColor(button, colorValue) {
    if (this.selectedColor === colorValue) {
      this.clearColor();
    } else {
      this.selectedColor = colorValue;
      this.colorButtons.forEach(btn => {
        if (btn === button) {
          btn.classList.add("selected");
        } else {
          btn.classList.remove("selected");
        }
      });

      document.querySelectorAll("[data-filter-color]").forEach(filterDisplay => {
        if (filterDisplay) {
            const span = filterDisplay.querySelector("span");
            if (this.selectedColor) {
                filterDisplay.classList.remove("hidden");
                if (span) span.textContent = this.selectedColor.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            } else {
                filterDisplay.classList.add("hidden");
                if (span) span.textContent = "";
            }
        }
      });
      
      const desktopColorStep = document.querySelector('.filter-step[data-step="color"]');
      if (desktopColorStep) desktopColorStep.setAttribute("data-active", "true");
      const mobileColorContent = document.querySelector('.mobile-accordion .accordion-content[data-step="color"]');
      if (mobileColorContent) mobileColorContent.setAttribute("data-active", "true");
    }
    this.filterSwatches();
    this.updateMobileAccordionState();
  }

  filterSwatches() {
    if (!this.swatchGrid) return;

    const allSwatchItems = this.swatchGrid.querySelectorAll(".swatch-item");
    const allPriceTiers = this.swatchGrid.querySelectorAll(".price-tier-section");
    const colorOptions = document.querySelectorAll('[data-step="color"] .color-option');
    
    let foundFabric = false;
    let foundWood = false;
    let foundLeather = false;
    const availableColors = new Set(); 

    allSwatchItems.forEach(item => {
        const itemRooms = item.dataset.rooms?.trim().split(" ").filter(Boolean) || [];
        const itemFurniture = item.dataset.furniture?.trim().split(" ").filter(Boolean) || [];
        const itemBrand = item.dataset.brand; 
        const itemMaterial = item.dataset.material?.toLowerCase();

        const roomMatch = this.selectedRooms.size === 0 || Array.from(this.selectedRooms).some(selected => itemRooms.includes(selected));
        const furnitureMatch = this.selectedFurniture.size === 0 || Array.from(this.selectedFurniture).some(selected => itemFurniture.includes(selected));
        const brandMatch = this.selectedBrands.size === 0 || this.selectedBrands.has(itemBrand);

        if (roomMatch && furnitureMatch && brandMatch) {
           if (itemMaterial === fabricJSLabel) foundFabric = true;
           if (itemMaterial === woodJSLabel) foundWood = true;
           if (itemMaterial === leatherJSLabel) foundLeather = true;
           item.classList.remove("hidden-swatch"); 
        } else {
           item.classList.add("hidden-swatch");
        }
        
    });

    // const fabricButton = document.querySelector('[data-step="material"] .option-button[data-filter-value="fabric"]');
    const fabricButton = document.querySelector(`[data-step="material"] .option-button[data-filter-value="${fabricJSLabel}"]`);
    // const woodButton = document.querySelector('[data-step="material"] .option-button[data-filter-value="wood"]');
    const woodButton = document.querySelector(`[data-step="material"] .option-button[data-filter-value="${woodJSLabel}"]`);
    const leatherButton = document.querySelector(`[data-step="material"] .option-button[data-filter-value="${leatherJSLabel}"]`);
    let materialChanged = false;

    if (fabricButton) {
        if (foundFabric) fabricButton.classList.remove('hidden');
        else fabricButton.classList.add('hidden');
    }
    if (woodButton) {
        if (foundWood) woodButton.classList.remove('hidden');
        else woodButton.classList.add('hidden');
    }

    if (leatherButton) {
        if (foundLeather) leatherButton.classList.remove('hidden');
        else leatherButton.classList.add('hidden');
    }

    if (foundFabric && !foundWood && !foundLeather) {
    if (this.selectedMaterial !== fabricJSLabel) {
        this.selectedMaterial = fabricJSLabel;
        materialChanged = true;
    }
} else if (!foundFabric && foundWood && !foundLeather) {
    if (this.selectedMaterial !== woodJSLabel) {
        this.selectedMaterial = woodJSLabel;
        materialChanged = true;
    }
} else if (!foundFabric && !foundWood && foundLeather) {
    if (this.selectedMaterial !== leatherJSLabel) {
        this.selectedMaterial = leatherJSLabel;
        materialChanged = true;
    }
} else if (
    (this.selectedMaterial === fabricJSLabel && !foundFabric) ||
    (this.selectedMaterial === woodJSLabel && !foundWood) ||
    (this.selectedMaterial === leatherJSLabel && !foundLeather)
) {
    this.selectedMaterial = null;
    materialChanged = true;
}

    if (fabricButton) {
        if (this.selectedMaterial === fabricJSLabel) fabricButton.classList.add('selected');
        else fabricButton.classList.remove('selected');
    }
    if (woodButton) {
        if (this.selectedMaterial === woodJSLabel) woodButton.classList.add('selected');
        else woodButton.classList.remove('selected');
    }

     if (materialChanged || this.selectedMaterial === null || 
        (this.selectedMaterial === fabricJSLabel && !fabricButton?.classList.contains('selected')) ||
        (this.selectedMaterial === woodJSLabel && !woodButton?.classList.contains('selected')) 
     ) {
        this.updateMaterialDisplay();
        if (this.selectedMaterial !== null) {
            this.colorStep.setAttribute("data-active", "true");
            const colorAccordion = document.querySelector('[data-accordion-toggle="color"]');
             if (colorAccordion) colorAccordion.classList.remove("disabled");
        } else {
             this.clearColor(true);
             this.colorStep.setAttribute("data-active", "false");
             const colorAccordion = document.querySelector('[data-accordion-toggle="color"]');
             if (colorAccordion) colorAccordion.classList.add("disabled");
        }
     }

    if (!this.selectedMaterial) {
        return this.hideAllSwatches(); 
    }

    allSwatchItems.forEach(item => {
        if (item.classList.contains("hidden-swatch")) return; 

        const itemMaterial = item.dataset.material?.toLowerCase();
        const itemColorFamily = item.dataset.colorFamily?.toLowerCase(); 

        const materialMatch = this.selectedMaterial === itemMaterial;
        const colorMatch = !this.selectedColor || this.selectedColor === itemColorFamily;

        if (materialMatch && colorMatch) {
            item.classList.remove("hidden-swatch");
            if (itemColorFamily) {
                availableColors.add(itemColorFamily); 
            }
        } else {
            item.classList.add("hidden-swatch");
        }
    });

    colorOptions.forEach(option => {
        const optionFamily = option.dataset.colorFamily?.toLowerCase() || option.dataset.filterValue?.toLowerCase();
        if (availableColors.has(optionFamily)) {
            option.classList.remove("hidden");
        } else {
            option.classList.add("hidden");
            if (this.selectedColor && this.selectedColor === optionFamily) {
                 this.clearColor(true);
            }
        }
    });

    allPriceTiers.forEach(tier => {
        const visibleSwatchesInTier = tier.querySelectorAll(".swatch-item:not(.hidden-swatch)");
        const priceTiersIntro = document.querySelector('.price-tier-section-intro');
        priceTiersIntro.style.display = 'block';
        tier.style.display = visibleSwatchesInTier.length > 0 ? "block" : "none"; 
        tier.classList.remove('price-tier-active'); 
    });
    
    // Optional: hide the intro if no tiers are visible
    // if (!hasShownIntro) {
    //     priceTiersIntro.style.display = 'none';
    // }

    if (this.isMobile()) {
      const visibleTiers = document.querySelectorAll(".price-tier-section:not([style*='display: none'])");
      visibleTiers.forEach((tier, index) => {
          tier.classList.add('price-tier-active', 'active');
          const header = tier.querySelector('.price-tier-header');
          if (index === 0) {
              if (header) {
                  header.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              } else {
                  tier.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
          }
      });
    }


    this.searchInputs.forEach(input => {
        if (input && input.value.trim()) {
            this.handleSearch(input); 
        }
    });
  }

  updateMaterialDisplay() {
    const filters = document.querySelectorAll("[data-filter-material]");
    filters.forEach(filter => {
        if (this.selectedMaterial) {
            filter.classList.remove("hidden");
            filter.querySelector("span").textContent = this.selectedMaterial;
        } else {
            filter.classList.add("hidden");
            filter.querySelector("span").textContent = "";
        }
    });
  }

  hideAllSwatches() {
      if (this.swatchGrid) {
          const allSwatchItems = this.swatchGrid.querySelectorAll(".swatch-item");
          const allPriceTiers = this.swatchGrid.querySelectorAll(".price-tier-section");

          allSwatchItems.forEach(item => {
              item.classList.add("hidden-swatch");
              item.classList.remove("search-hidden"); 
          });

          allPriceTiers.forEach(tier => {
              tier.style.display = "none";
              tier.classList.remove('price-tier-active'); 
          });
      }
      const colorOptions = document.querySelectorAll('[data-step="color"] .color-option');
      colorOptions.forEach(option => option.classList.add('hidden'));
      if (!this.selectedMaterial) {
          this.updateMaterialDisplay();
      }
  }

  updateOrderButtonState() {
    if (!this.orderButtons || this.orderButtons.length === 0) return;
    const isDisabled = this.selectedSwatches.size === 0;
    this.orderButtons.forEach(button => {
        button.disabled = isDisabled;
    });
  }

  clearRooms() {
    this.selectedRooms.clear();
    this.roomButtons.forEach(button => button.classList.remove("selected"));
    this.updateSelectedDisplay(this.selectedRoomFilter, this.selectedRooms, "room");
    this.clearFurniture(); 
    this.updateFurnitureVisibility();
    this.updateStep2Headings();
    this.updateMobileAccordionState();
  }

  clearFurniture() {
    this.selectedFurniture.clear();
    this.furnitureButtons.forEach(button => button.classList.remove("selected"));
    this.updateSelectedDisplay(this.selectedFurnitureFilter, this.selectedFurniture, "furniture"); 
    this.clearBrands(); 
    this.updateBrandVisibility(); 
  }

  clearBrands() {
    this.selectedBrands.clear();
    this.brandButtons.forEach(button => button.classList.remove("selected"));
    this.updateSelectedDisplay(this.selectedBrandFilter, this.selectedBrands, "brand"); 
    this.updateMaterialVisibility(); 
    this.filterSwatches(); // Re-filter after clearing brands
    this.updateMobileAccordionState();
  }

  clearMaterial(preventRefilter = false) {
    this.selectedMaterial = null;
    this.materialButtons.forEach(button => button.classList.remove("selected"));
    this.updateMaterialDisplay();

    if (this.selectedBrands.size === 0) {
      this.materialStep.setAttribute("data-active", "false");
    } else {
      this.materialStep.setAttribute("data-active", "true");
    }
    
    this.clearColor(true); 
    this.colorStep.setAttribute("data-active", "false");
    const colorAccordion = document.querySelector('[data-accordion-toggle="color"]');
    if (colorAccordion) colorAccordion.classList.add("disabled");

    if (!preventRefilter) {
        this.filterSwatches(); 
    }
    this.updateMobileAccordionState();
  }

  clearColor(preventRefilter = false) {
    this.selectedColor = null;
    this.colorButtons.forEach(button => button.classList.remove("selected"));
    document.querySelectorAll("[data-filter-color]").forEach(filterDisplay => {
      if(filterDisplay) {
        filterDisplay.classList.add("hidden");
        const span = filterDisplay.querySelector("span");
        if (span) span.textContent = "";
      }
    });

    if (!preventRefilter) {
        this.filterSwatches();
    }
    this.updateMobileAccordionState();
  }

  clearSearch() {
    this.searchInputs.forEach(input => {
      input.value = '';
    });
    // this.searchClearButton.style.display = "none";
    const swatchItems = document.querySelectorAll(".swatch-item");
    const priceTierSections = document.querySelectorAll(".price-tier-section");

    const priceTierSectionIntro2 = document.querySelectorAll(".price-tier-section-intro");
    console.log(priceTierSectionIntro2);
    // priceTierSectionIntro2.style.display = "none";

    swatchItems.forEach(swatch => {
      if (!swatch.classList.contains("hidden-swatch")) {
        swatch.style.display = "block";
      }
      swatch.classList.remove('search-hidden');
    });

    priceTierSections.forEach(section => {
      const visibleSwatches = Array.from(section.querySelectorAll(".swatch-item"))
        .filter(swatch => !swatch.classList.contains("hidden-swatch"));
      section.style.display = visibleSwatches.length > 0 ? "block" : "none";
    });

    if (typeof this.filterSwatches === 'function') {
      this.filterSwatches();
    }
  }

  updateStep2Headings() {
    if (!this.step2RoomSelectedTextElements.length && !this.step2TitleTextElements.length) {
      return;
    }

    const selectedRoomNames = Array.from(this.selectedRooms)
      .map(roomHandle => this.roomData.get(roomHandle)?.name)
      .filter(name => name);
    const displayText = selectedRoomNames.join(', ');

    this.step2RoomSelectedTextElements.forEach(el => {
      el.textContent = displayText;
    });

    const noRoomTitle = this.getText('textStep2NoRoom', '2. Choose Furniture');
    const withRoomPrefix = this.getText('textStep2WithRoomPrefix', '2. Choose furniture for:');

    this.step2TitleTextElements.forEach(el => {
      if (selectedRoomNames.length > 0) {
        el.textContent = `${withRoomPrefix} ${displayText}`;
      } else {
        el.textContent = noRoomTitle;
      }
    });
  }

  generateSwatchId(e) {
    if (!e) {
      return `swatch-fallback-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }
    // Use the markup's data-swatch-id if available
    const existingId = e.dataset.swatchId;
    if (existingId && existingId.startsWith("swatch-")) {
      return existingId;
    }
    // Fallback to title-based ID
    const title = e.querySelector(".swatch-title")?.textContent?.trim().replace(/\s+/g, '-') || 'unnamed';
    const uniqueId = `swatch-${title}-${Date.now()}`;
    e.dataset.swatchId = uniqueId;
    return uniqueId;
  }

  toggleSwatchSelection(e) {
    if (!e || !e.dataset) {
      return;
    }

    if (e.dataset.isProcessing) {
      return;
    }
    e.dataset.isProcessing = "true";

    const swatchId = this.generateSwatchId(e);
    e.dataset.swatchId = swatchId;

    if (this.selectedSwatches.has(swatchId)) {
      this.removeSelection(swatchId);
    } else {
      this.addSelection(e, swatchId);
    }

    this.updateRemainingSlots();
    this.updateSwatchCountDisplay();

    setTimeout(() => {
      delete e.dataset.isProcessing;
    }, 100);
  }

  showMaxSwatchLimitMessage() {
    this.swatchLimitErrorMessages.forEach(msg => {
      if (msg) {
        msg.style.display = 'block';
      }
    });
  }

  hideMaxSwatchLimitMessage() {
    this.swatchLimitErrorMessages.forEach(msg => {
      if (msg) {
        msg.style.display = 'none';
      }
    });
  }

  addSelection(e, swatchId) {
    if (this.selectedSwatches.has(swatchId)) {
      this.showDuplicateWarning();
      return;
    }

    if (this.selectedSwatches.size >= this.maxSelections) {
      this.showMaxSwatchLimitMessage();
      return;
    }
    this.hideMaxSwatchLimitMessage();

    const swatchData = this.extractSwatchData(e, swatchId);
    if (!swatchData) {
      return;
    }

    this.selectedSwatches.set(swatchId, { element: e, savedData: swatchData });
    e.classList.add("selected");

    const grids = [
      ".selected-swatches-grid",
      ".swatch_form_selected_swatches .selected-swatches-grid",
      ".mobile-swatches-panel .selected-swatches-grid"
    ];

    grids.forEach(selector => {
      const grid = document.querySelector(selector);
      if (!grid) {
        return;
      }

      if (grid.querySelector(`.selected-swatch-slot[data-swatch-id="${swatchId}"]`)) {
        return;
      }

      const slot = document.createElement("div");
      slot.className = "selected-swatch-slot";
      slot.dataset.swatchId = swatchId;
      slot.innerHTML = this.createSelectedSwatchContent(swatchData);

      const remainingSlots = grid.querySelector(".remaining-slots");
      if (remainingSlots) {
        grid.insertBefore(slot, remainingSlots);
      } else {
        grid.appendChild(slot);
      }
    });

    this.addToMiniCart(swatchData);
    this.updateHiddenFields();
    this.saveSwatchesToLocalStorage();
    this.updateRemainingSlots();
    this.updateSwatchCountDisplay();
    this.updateOrderButtonState();
  }

  extractSwatchData(e, swatchId) {
    if (!e || !e.dataset) {
      return null;
    }

    const titleElement = e.querySelector(".swatch-title");
    const imgElement = e.querySelector("img");
    if (!titleElement || !imgElement) {
      return null;
    }

    const data = {
      id: swatchId,
      title: titleElement.textContent?.trim() || "Unnamed Swatch",
      imgSrc: imgElement.src || "",
      furniture: e.dataset.furniture || "",
      rooms: e.dataset.rooms || "",
      brand: e.dataset.brand || "",
      material: e.dataset.material || "",
      color: e.dataset.color || "",
      colorFamily: e.dataset.colorFamily || "",
      priceTier: e.dataset.priceTier || "",
      description: e.dataset.description || "",
      composition: e.dataset.composition || "",
      rubCount: e.dataset.rubCount || "",
      goodFor: e.dataset.goodFor || "",
      compatibleProducts: e.dataset.compatibleProducts || "",
      primaryCollection: e.dataset.primaryCollection || ""
    };

    return data;
  }

  updateRemainingSlots() {
    const count = this.selectedSwatches.size;
    let remaining = this.maxSelections - count;
    if (remaining < 0) remaining = 0;

    const grids = [".selected-swatches-grid", ".swatch_form_selected_swatches .selected-swatches-grid"];
    const singularTextTemplate = this.getText('textRemainingSingular', 'Space for {count} more swatch');
    const pluralTextTemplate = this.getText('textRemainingPlural', 'Space for {count} more swatches');

    grids.forEach(selector => {
      const grid = document.querySelector(selector);
      if (!grid) return;

      let slotsElement = grid.querySelector(".remaining-slots");

      if (slotsElement) {
        slotsElement.remove();
        slotsElement = null;
      }

      if (remaining > 0 && grid.querySelectorAll(".selected-swatch-slot").length < this.maxSelections) {
        slotsElement = document.createElement("div");
        slotsElement.className = "remaining-slots";
        const slotsText = remaining === 1 ? singularTextTemplate.replace('{count}', remaining) : pluralTextTemplate.replace('{count}', remaining);
        slotsElement.innerHTML = `
          <div class="remaining-slots-image">+${remaining}</div>
          <div class="remaining-slots-text">
              ${slotsText}
          </div>
        `;
        if (grid.querySelectorAll(".selected-swatch-slot").length < this.maxSelections) {
          grid.appendChild(slotsElement);
        }
      }
    });
  }

  createSelectedSwatchContent(swatchData) {
    const removeButtonText = this.getText('textRemoveButton', 'Remove');
    if (!swatchData || !swatchData.title || !swatchData.imgSrc) {
      return `
        <img src="" alt="Unnamed Swatch">
        <div class="selected-swatch-info">
          <p class="selected-swatch-title">Unnamed Swatch</p>
        </div>
        <button class="remove-selected">${removeButtonText}</button>
      `;
    }

    const { title, imgSrc } = swatchData;
    return `
      <img src="${imgSrc}" alt="${title}">
      <div class="selected-swatch-info">
        <p class="selected-swatch-title">${title}</p>
      </div>
      <button class="remove-selected">${removeButtonText}</button>
    `;
  }

  removeSelection(swatchId) {
    const selectedSwatch = this.selectedSwatches.get(swatchId);
    if (!selectedSwatch) return;

    const deleted = this.selectedSwatches.delete(swatchId);

    if (deleted) {
        if (this.selectedSwatches.size < this.maxSelections) {
          this.hideMaxSwatchLimitMessage();
        }
        const grids = [".selected-swatches-grid", ".swatch_form_selected_swatches .selected-swatches-grid"];
        grids.forEach(selector => {
          const grid = document.querySelector(selector);
          if (grid) {
            const slotToRemove = grid.querySelector(`.selected-swatch-slot[data-swatch-id="${swatchId}"]`);
            if (slotToRemove) slotToRemove.remove();
          }
        });

        if (selectedSwatch.element) {
          selectedSwatch.element.classList.remove("selected");
        }

        const mobileGrid = document.querySelector(".mobile-swatches-panel .selected-swatches-grid");
        if (mobileGrid) {
          const mobileSlotToRemove = mobileGrid.querySelector(`.selected-swatch-slot[data-swatch-id="${swatchId}"]`);
          if (mobileSlotToRemove) mobileSlotToRemove.remove();
        }

        this.removeFromMiniCart(swatchId);
        this.updateHiddenFields();

        this.saveSwatchesToLocalStorage();
        this.updateRemainingSlots();
        this.updateSwatchCountDisplay();
        this.updateOrderButtonState();
    } else {

    }
  }

  showMaxSelectionWarning() { 
    const warning = document.createElement('div');
    warning.className = 'swatch-selection-full';
    warning.textContent = this.getText('textMaxSelectionWarning', 'Maximum of 4 swatches can be selected');
    document.body.appendChild(warning);

    setTimeout(() => {
      warning.remove();
    }, 3000);
  }

  saveSwatchesToLocalStorage() {
    try {
        const swatches = Array.from(this.selectedSwatches.entries()).map(([id, data]) => ({
            id,
            title: data.savedData.title || data.element?.querySelector(".swatch-title")?.textContent || "",
            imgSrc: data.savedData.imgSrc || data.element?.querySelector("img")?.src || ""
        }));
        localStorage.setItem("selectedSwatches", JSON.stringify(swatches));
    } catch (e) {

    }
  }

  clearAllSelectedSwatches() {
    const swatchIds = Array.from(this.selectedSwatches.keys());

    swatchIds.forEach(id => {
      const selectionData = this.selectedSwatches.get(id);

      if (selectionData && selectionData.element) {
        selectionData.element.classList.remove('selected');
      } else {
        const swatchItem = this.swatchGrid?.querySelector(`.swatch-item[data-swatch-id="${id}"]`);
        if (swatchItem) {
          swatchItem.classList.remove('selected');
        }
      }

      const selectors = [
        `.selected-swatches-grid .selected-swatch-slot[data-swatch-id="${id}"]`,
        `.swatch_form_selected_swatches .selected-swatch-slot[data-swatch-id="${id}"]`,
        `.mobile-swatches-panel .selected-swatch-slot[data-swatch-id="${id}"]`,
        `.mini-cart-item[data-swatch-id="${id}"]`
      ];

      selectors.forEach(selector => {
        const elementToRemove = document.querySelector(selector);
        if (elementToRemove) {
          elementToRemove.remove();
        }
      });
    });

    this.selectedSwatches.clear();
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('selectedSwatches');
      }
    } catch (e) {

    }
    this.updateRemainingSlots();
        this.updateHiddenFields();
        this.updateMobileSwatchesCount();
        this.updateMiniCartCount();
        this.updateOrderButtonState();
  }

  updateMiniCartCount() {
    const countElement = document.querySelector(".swatch-mini-cart .mini-cart-count");
    const itemsContainer = document.querySelector(".swatch-mini-cart .mini-cart-items");
    if (countElement && itemsContainer) {
        countElement.textContent = itemsContainer.children.length;
    }
  }

  loadSavedSwatches() {
    if (this.hasLoadedSwatches) {
        return;
    }
    try {
        if (typeof localStorage === "undefined") return;

        const savedDataArray = JSON.parse(localStorage.getItem("selectedSwatches")) || [];
        if (savedDataArray.length === 0) {
            this.updateRemainingSlots();
            this.updateSwatchCountDisplay();
            this.updateOrderButtonState();
            this.hasLoadedSwatches = true;
            return;
        }

        this.selectedSwatches.clear();
        const gridsSelectors = [".selected-swatches-grid", ".swatch_form_selected_swatches .selected-swatches-grid"];
        gridsSelectors.forEach(selector => {
            const grid = document.querySelector(selector);
            if (grid) {
                grid.querySelectorAll(".selected-swatch-slot").forEach(slot => slot.remove());
                const remaining = grid.querySelector('.remaining-slots');
                if (remaining) remaining.remove();
            }
        });
        const miniCartItems = document.querySelector(".swatch-mini-cart .mini-cart-items");
        if (miniCartItems) miniCartItems.innerHTML = '';

        savedDataArray.slice(0, this.maxSelections).forEach(savedData => {
            if (!savedData || !savedData.id || typeof savedData.title === 'undefined') {
                return;
            }

            if (this.selectedSwatches.size >= this.maxSelections) {
                return;
            }

            let swatchElement = document.querySelector(`.swatch-item[data-swatch-id="${savedData.id}"]`);
            if (!swatchElement) {
                document.querySelectorAll(".swatch-item").forEach(item => {
                    if (!swatchElement && (item.querySelector(".swatch-title")?.textContent || "") === savedData.title) {
                        swatchElement = item;
                        swatchElement.dataset.swatchId = savedData.id;
                    }
                });
            }

            this.selectedSwatches.set(savedData.id, { element: swatchElement, savedData: savedData });

            if (swatchElement) {
                swatchElement.classList.add("selected");
            }

            gridsSelectors.forEach(selector => {
                const grid = document.querySelector(selector);
                if (grid && this.selectedSwatches.size <= this.maxSelections) {
                    if (!grid.querySelector(`.selected-swatch-slot[data-swatch-id="${savedData.id}"]`)) {
                        const slotDiv = document.createElement("div");
                        slotDiv.className = "selected-swatch-slot";
                        slotDiv.dataset.swatchId = savedData.id;
                        slotDiv.innerHTML = `
                            <img src="${savedData.imgSrc || ''}" alt="${savedData.title}">
                            <div class="selected-swatch-info">
                                <p class="selected-swatch-title">${savedData.title}</p>
                            </div>
                            <button class="remove-selected">Remove</button>
                        `;
                        grid.appendChild(slotDiv);
                    }
                }
            });

            this.addToMiniCart(savedData);
        });

        this.updateRemainingSlots();
        this.updateHiddenFields();
        this.updateSwatchCountDisplay();
        this.updateStep2Headings();
        this.updateOrderButtonState();
        this.hasLoadedSwatches = true;
    } catch (error) {
        this.selectedSwatches.clear();
        try { localStorage.removeItem("selectedSwatches"); } catch (e) {}
        this.updateRemainingSlots();
        this.updateHiddenFields();
        this.updateSwatchCountDisplay();
        this.updateOrderButtonState();
        this.hasLoadedSwatches = true;
    }
  }

  createMiniCart() {
    if (document.querySelector('.swatch-mini-cart')) return;
    
    const miniCart = document.createElement('div');
    miniCart.className = 'swatch-mini-cart';
    miniCart.innerHTML = `
      <div class="mini-cart-header">
        <h3>Your Swatches</h3>
        <span class="mini-cart-count">0</span>
        <button class="mini-cart-toggle">▼</button>
      </div>
      <div class="mini-cart-items"></div>
    `;
    
    document.body.appendChild(miniCart);
  }

  addToMiniCart(swatch) {
    this.createMiniCart();
    
    const miniCartItems = document.querySelector('.swatch-mini-cart .mini-cart-items');
    const miniCartCount = document.querySelector('.swatch-mini-cart .mini-cart-count');
    
    if (!miniCartItems) return;
    
    const existingItem = miniCartItems.querySelector(`.mini-cart-item[data-swatch-id="${swatch.id}"]`);
    if (existingItem) return;
    
    const miniCartItem = document.createElement('div');
    miniCartItem.className = 'mini-cart-item';
    miniCartItem.dataset.swatchId = swatch.id;
    miniCartItem.innerHTML = `
      <img src="${swatch.imgSrc}" alt="${swatch.title}">
      <span class="mini-cart-item-title">${swatch.title}</span>
      <button class="mini-cart-remove" data-swatch-id="${swatch.id}">×</button>
    `;
    
    miniCartItems.appendChild(miniCartItem);
    
    if (miniCartCount) {
      miniCartCount.textContent = miniCartItems.children.length;
    }
  }

  removeFromMiniCart(swatchId) {
    const miniCartItem = document.querySelector(`.mini-cart-item[data-swatch-id="${swatchId}"]`);
    if (miniCartItem) {
      miniCartItem.remove();
      
      const miniCartCount = document.querySelector('.swatch-mini-cart .mini-cart-count');
      const miniCartItems = document.querySelector('.swatch-mini-cart .mini-cart-items');
      if (miniCartCount && miniCartItems) {
        miniCartCount.textContent = miniCartItems.children.length;
      }
    }
  }

  
}

document.addEventListener("DOMContentLoaded", () => {
  window.swatchFilter = new SwatchFilter();
});

document.querySelectorAll('.swatch-item').forEach(item => {
  item.addEventListener('click', () => {
    window.swatchFilter.toggleSwatchSelection(item);
  });
});

document.addEventListener('shopify:section:load', () => {
  if (!window.swatchFilter) {
    window.swatchFilter = new SwatchFilter();
  } else {
    window.swatchFilter.bindEvents();
    window.swatchFilter.loadSavedSwatches();
  }
});

// Swatch Info Panel Logic
document.addEventListener("DOMContentLoaded", () => {
  const panel = document.querySelector(".swatch-info-panel");
  if (!panel) return;
  const content = panel.querySelector(".swatch-info-content");
  const closeButton = panel.querySelector(".swatch-info-close");
  const mainFilterNavContainer = document.querySelector("[data-filter-navigation]"); // Get the main container

  function getTextFromMainContainer(key, fallbackText) {
    if (mainFilterNavContainer && mainFilterNavContainer.dataset[key]) {
      return mainFilterNavContainer.dataset[key];
    }
    return fallbackText;
  }

  function parseRichText(text) {
    if (!text) return "";
    try {
      return (function(raw) {
        if (!raw) return "";
        try {
          const formatted = raw.replace(/=>/g, ":");
          const parsed = JSON.parse(formatted);
          return parsed && parsed.type === "root" && Array.isArray(parsed.children)
            ? parsed.children.map(child => child.type === "paragraph" && Array.isArray(child.children) ? child.children.map(c => c.value || "").join("") : "").join("<br>")
            : raw;
        } catch (error) {
          return raw;
        }
      })(text);
    } catch {
      return text.replace(/\\"/g, '"').replace(/\\n/g, "<br>");
    }
  }

  document.addEventListener("click", (event) => {
    const infoButton = event.target.closest(".swatch-info-button");
    if (infoButton) {
      event.preventDefault();
      const swatchItem = infoButton.closest(".swatch-item");
      if (!swatchItem) return;

      swatchItem.dataset.swatchId = swatchItem.dataset.swatchId || `swatch-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      const swatchId = swatchItem.dataset.swatchId;
      const title = swatchItem.querySelector(".swatch-title")?.textContent || "";
      const brand = swatchItem.getAttribute("data-brand") || "";
      const color = swatchItem.getAttribute("data-color") || "";
      const description = parseRichText(swatchItem.getAttribute("data-description"));
      const composition = parseRichText(swatchItem.getAttribute("data-composition"));
      const rubCount = parseRichText(swatchItem.getAttribute("data-rub-count"));
      const goodFor = parseRichText(swatchItem.getAttribute("data-good-for"));
      const imgSrc = swatchItem.querySelector("img")?.getAttribute("src") || "";
      let compatibleProducts = [];
      try {
        const raw = swatchItem.getAttribute("data-compatible-products");
        if (raw && raw.trim() !== "") {
          compatibleProducts = JSON.parse(raw);
        }
      } catch (err) {
        // console.error("Error parsing compatible products:", err);
      }

      panel.dataset.currentSwatchId = swatchId;
      let productsHtml = "";
      const hasProducts = Array.isArray(compatibleProducts) && compatibleProducts.length > 0;

      if (hasProducts) {
        productsHtml = `
          <div class="featured-products compatible-products">
            <div class="swiper-container compatible-products-slider">
              <div class="swiper-wrapper">
                ${compatibleProducts.map(product => `
                  <div class="swiper-slide">
                    <div class="product-item">
                      <a href="${product.url}" class="product-image">
                        <img class="main-image" src="${product.image}" alt="${product.title}">
                        ${product.hover_image ? `<img class="hover-image" src="${product.hover_image}" alt="${product.title}">` : ""}
                      </a>
                      <div class="product-info">
                        <div class="product-vendor">${product.vendor || ""}</div>
                        <h4 class="product-title">${product.title || ""}</h4>
                        <div class="product-price">${product.price || ""}</div>
                      </div>
                    </div>
                  </div>
                `).join("")}
              </div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-scrollbar"></div>
            </div>
          </div>
        `;
      }
      
      const addButtonText = getTextFromMainContainer('textInfoPanelAddButton', 'Add to swatches');
      const compositionLabel = getTextFromMainContainer('textInfoPanelComposition', 'Composition:');
      const rubCountLabel = getTextFromMainContainer('textInfoPanelRubCount', 'Rub Count:');
      const goodForLabel = getTextFromMainContainer('textInfoPanelGoodFor', 'Good For:');
      const compatibleTitle = getTextFromMainContainer('textInfoPanelCompatibleTitle', 'Compatible with');
      const compatiblePrefixHtml = getTextFromMainContainer('textInfoPanelCompatiblePrefix', '<p>These fabrics are available for ALL </p>');
      const compatibleSuffixHtml = getTextFromMainContainer('textInfoPanelCompatibleSuffix', '<p> products, including:</p>');

      let finalCompatibleTextHtml = "";
      if(hasProducts){
        finalCompatibleTextHtml = `${compatiblePrefixHtml} <span class="compatibale_brand">${brand}</span> ${compatibleSuffixHtml}`;
      }


      content.innerHTML = `
        <div class="swatch-info-content-inner">
          <div class="swatch-info-image">
            <h5 class="mob_swatch_brand">${brand}</h5>
            <h2 class="mob_swatch_title">${title}</h2>
            <img src="${imgSrc}" alt="${title}">
            <button class="add_to_swatches swipe-green-button" data-swatch-id="${swatchId}">${addButtonText}</button>
          </div>
          <div class="swatch-info-details">
            <h5 class="desk_swatch_brand">${brand}</h5>
            <h2 class="desk_swatch_title">${title}</h2>
            <h4>${color}</h4>
            ${description ? `<p>${description}</p>` : ""}
            ${composition ? `<h4>${compositionLabel}</h4><p>${composition}</p>` : ""}
            ${rubCount ? `<h4>${rubCountLabel}</h4><p>${rubCount}</p>` : ""}
            ${goodFor ? `<h4>${goodForLabel}</h4><p>${goodFor}</p>` : ""}
          </div>
          ${hasProducts ? `
            <div class="compatible-products-section">
              <h4>${compatibleTitle}</h4>
              ${finalCompatibleTextHtml}
              ${productsHtml}
            </div>
          ` : ""}
        </div>
      `;

      panel.classList.add("open");

      if (hasProducts && typeof Swiper !== 'undefined') {
        setTimeout(() => {
          new Swiper(".compatible-products-slider", {
            slidesPerView: 3,
            spaceBetween: 4,
            pagination: { el: ".swiper-pagination", clickable: true },
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
            scrollbar: { el: ".swiper-scrollbar", draggable: true, hide: true },
            breakpoints: { 480: { slidesPerView: 2 }, 768: { slidesPerView: 3 } }
          });
        }, 10);
      }
    }
  });

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      panel.classList.remove("open");
    });
  }

  document.addEventListener("click", (event) => {
    if (panel && !panel.contains(event.target) && !event.target.closest(".swatch-info-button")) {
      panel.classList.remove("open");
    }
  });
});

// Accordion Functionality
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 768) {
    const priceTierHeadings = document.querySelectorAll('.price-tier-heading');
    priceTierHeadings.forEach(heading => {
      heading.addEventListener('click', function() {
        this.classList.toggle('active');
        const parentSection = this.closest('.price-tier-section');
        parentSection.classList.toggle('active');
      });
    });
  }

  window.addEventListener('resize', () => {
    const priceTierSections = document.querySelectorAll('.price-tier-section');
    if (window.innerWidth >= 768) {
      priceTierSections.forEach(section => {
        section.classList.remove('active');
        const heading = section.querySelector('.price-tier-heading');
        heading.classList.remove('active');
        const swatchGrid = section.querySelector('.swatch-grid');
        swatchGrid.style.maxHeight = 'none';
      });
    }
  });
});

document.addEventListener("click", function(e) {
  const addToSwatchesButton = e.target.closest(".add_to_swatches");
  if (addToSwatchesButton) {
    e.preventDefault();
    const swatchIdFromButton = addToSwatchesButton.dataset.swatchId;
    
    let swatchElement = null;
    const infoPanel = document.querySelector(".swatch-info-panel");
    let currentSwatchIdForLookup = swatchIdFromButton;

    if (infoPanel && infoPanel.classList.contains('open') && infoPanel.dataset.currentSwatchId) {
        currentSwatchIdForLookup = infoPanel.dataset.currentSwatchId;
    }
    
    if (currentSwatchIdForLookup) {
        swatchElement = document.querySelector(`.swatch-item[data-swatch-id="${currentSwatchIdForLookup}"]`);
    }
    
    if (!swatchElement) {
        swatchElement = addToSwatchesButton.closest('.swatch-item');
    }

    if (window.swatchFilter) {
      if (swatchElement) {
        if (!swatchElement.dataset.swatchId && currentSwatchIdForLookup) {
             swatchElement.dataset.swatchId = currentSwatchIdForLookup;
        } else if (!swatchElement.dataset.swatchId) {
             swatchElement.dataset.swatchId = window.swatchFilter.generateSwatchId(swatchElement);
        }
        window.swatchFilter.toggleSwatchSelection(swatchElement);
      } else {

      }

      if (infoPanel) infoPanel.classList.remove("open");
    } else {
      console.warn("SwatchFilter instance not found.");
      if (infoPanel) infoPanel.classList.remove("open");
    }
  }
});




  } catch(e) { console.error(e); }
})();
})();
